import _ from 'lodash';
import React from 'react';
import { MdSave, MdDelete } from 'react-icons/md';
import Crud from '~/components/crud';
import confirm from '~/components/confirm';
import { formats } from '~/helper';
import { EmailsTemplateForm, EmailsTemplateSchema, typesList } from '~/views/emails-template/form';
import { Container } from '~/views/emails-template/styles';
import useEmailsTemplate from '~/view-data/use-emails-template';

const columns = [
  {
    name: 'Tipo',
    selector: 'type',
    width: '250px',
    format: (r) => _.get(_.find(typesList, { value: r.type }), 'label') || ''
  },
  {
    name: 'Assunto',
    selector: 'subject'
  },
  {
    name: 'Local',
    width: '200px',
    selector: 'place',
    format: (r) => _.get(r, 'place.name')
  },
  {
    name: 'Cadastrado em',
    width: '160px',
    selector: 'createdAt',
    hide: 'md',
    format: (row) => formats.dateTimeZone(_.get(row, 'createdAt'), 'dd/MM/yyyy HH:mm')
  },
];

function EmailsTemplate({ acls }) {
  const canWrite = acls.includes('W');
  const { state, actions } = useEmailsTemplate();

  const handleRemove = async (data, action) => {
    const result = await confirm.show({
      title: 'Atenção',
      text: `Deseja realmente remover esse modelo de email?`,
    });

    if (result) {
      actions.remove(data, action);
    }
  };

  const actionsList = [
      {
        label: 'Salvar',
        icon: MdSave,
        isSubmit: true,
        isDisabled: ({ isValid }) => !isValid || !canWrite,
        action: actions.createOrUpdate,
      }
    ];

  if (_.get(state, 'model.id')) {
    actionsList.push({
        label: 'Remover',
        icon: MdDelete,
        isDisabled: ({ isValid }) => !canWrite,
        action: handleRemove,
      });
  }

  return (
    <Container>
      <Crud
        columns={columns}
        emptyText='Nenhum modelo de email encontrado'
        data={state.data}
        hideAdd={!canWrite}
        rightWidth="720px"
        tableLoading={state.loading}
        formLoading={state.formLoading}
        formTitle={(data) => (_.get(data, 'id')) ? `Modelo de email #${data.id}` : `Novo modelo de email`}
        onChangePage={actions.pageChange}
        onRowClicked={actions.load}
        formOptions={{
          validationSchema: EmailsTemplateSchema,
          initialValues: state.model,
          initialTouched: { contents: true },
        }}
        renderForm={(args) => <EmailsTemplateForm onListPlaces={actions.listPlaces} {...args} previewMode={!canWrite} />}
        actions={actionsList}
      />
    </Container>
  );
}

export default EmailsTemplate;
